import React, { useEffect, useState } from 'react';
import css from './CommunityComponent.module.css';

import instagram from '../../assets/instagram.png';
import whatsapp from '../../assets/whatsapp.png';
import googleplay from '../../assets/google-play.png';

function CommunityComponent() {
  const [mounted, setMounted] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState({
    isIOS: false,
    isAndroid: false,
  });

  useEffect(() => {
    setMounted(true);

    if (typeof window !== 'undefined') {
      const ua = navigator.userAgent || '';

      setDeviceInfo({
        isIOS: /iphone|ipad|ipod|mac/i.test(ua),
        isAndroid: /android|windows/i.test(ua),
      });
    }
  }, []);

  if (!mounted) return null;

  const IOS_STORE_URL = process.env.REACT_APP_IOS_APP_STORE_URL;
  const ANDROID_STORE_URL = process.env.REACT_APP_ANDROID_PLAY_STORE_URL;

  const storeUrl = deviceInfo.isIOS
    ? IOS_STORE_URL || ANDROID_STORE_URL
    : deviceInfo.isAndroid
      ? ANDROID_STORE_URL || IOS_STORE_URL
      : IOS_STORE_URL || ANDROID_STORE_URL;

  return (
    <section className={css.section}>
      <h3>Join Our Community</h3>

      <div className={css.linksContainer}>
        <a
          href="https://whatsapp.com/channel/0029VbCFnZPLNSZy4AZ1Ea3w"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={whatsapp} alt="" />
          Whatsapp Community
        </a>

        <a
          href="https://www.instagram.com/purfurry?igsh=azZxMm1xNWN1MzBo"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={instagram} alt="" />
          Instagram Community
        </a>

        {storeUrl && (
          <a
            href={storeUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={googleplay} alt="" />
            Download The Purfurry App!
          </a>
        )}
      </div>
    </section>
  );
}

export default CommunityComponent;